const Logo = () => {
  return (
    <img 
      src="/lovable-uploads/new-logo.png" 
      alt="CHM Construction Ltd - Customers Happy Mind" 
      className="h-16 w-auto max-w-[200px] object-contain"
      width="99"
      height="64"
      loading="eager"
      fetchPriority="high"
      decoding="sync"
    />
  );
};

export default Logo;